<script lang="ts">
  import { slide } from "svelte/transition";

  export let s: Record<string, string>;
  export let faqItems: Array<{question: string; answer: string}> = [];
  export let sendFaq: (faq: {question: string; answer: string}) => void;
</script>

<div class={s.faqItemsWrapper} out:slide={{ axis: "y" }}>
  {#each faqItems as item}
    <div 
      class={s.faqItem} 
      on:click={() => sendFaq(item)}
      on:keydown={(e) => e.key === 'Enter' && sendFaq(item)}
      tabindex="0"
      role="button"
    >
      {item.question}
    </div>
  {/each}
</div>
